(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sk-cart-loading"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.getElementById('sk-cart-loading');
    if (!overlay) return;
    var safety = null;

    function show() {
      overlay.hidden = false;
      clearTimeout(safety);
      safety = setTimeout(hide, 6000);
    }
    function hide() {
      overlay.hidden = true;
      clearTimeout(safety);
    }

    // Volg de .loading-class die Dawn op de toevoegen-knop(pen) zet:
    // aan = bezig met toevoegen -> toon overlay; weg = klaar -> verberg.
    function watch(btn) {
      if (btn.dataset.skCartWatched) return;
      btn.dataset.skCartWatched = '1';
      new MutationObserver(function () {
        if (btn.classList.contains('loading')) show();
        else hide();
      }).observe(btn, { attributes: true, attributeFilter: ['class'] });
    }

    function scan() {
      document
        .querySelectorAll('.product-form__submit, product-form button[name="add"]')
        .forEach(watch);
    }

    scan();
    // Quick-add-modal voegt later knoppen toe -> opnieuw scannen bij klik.
    document.addEventListener('click', function () { setTimeout(scan, 300); }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-cookie-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var banner = document.getElementById('sk-cookie-banner');
    if (!banner) return;
    var KEY = 'sk-cookie-choice';
    var accept = document.getElementById('sk-cookie-accept');
    var reject = document.getElementById('sk-cookie-reject');

    function hide() { banner.hidden = true; }
    function remember(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function chosen() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }

    function setConsent(grant) {
      if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(
          { marketing: grant, analytics: grant, preferences: grant, sale_of_data: grant },
          function () {}
        );
      }
    }

    if (accept) accept.addEventListener('click', function () { setConsent(true); remember('accepted'); hide(); });
    if (reject) reject.addEventListener('click', function () { setConsent(false); remember('rejected'); hide(); });

    if (!chosen()) { banner.hidden = false; }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sk-page-loading"] && !Shopify.designMode) return;
  try {
    (function () {
    var overlay = document.getElementById('sk-page-loading');
    if (!overlay) return;
    var safety = null;

    function show() {
      overlay.hidden = false;
      clearTimeout(safety);
      safety = setTimeout(hide, 8000);
    }
    function hide() {
      overlay.hidden = true;
      clearTimeout(safety);
    }

    // Toon de overlay zodra de pagina daadwerkelijk weg navigeert.
    // Geen e.preventDefault()/returnValue -> geen "pagina verlaten?"-dialoog.
    window.addEventListener('beforeunload', show);

    // Terugkeer via terug-/vooruit-knop (bfcache) of een hersteld scherm: verbergen.
    window.addEventListener('pageshow', hide);
    window.addEventListener('pagehide', function () { clearTimeout(safety); });
  })();
  } catch(e) { console.error(e); }
})();

})();
